import { Link } from "react-router-dom";

import styled from "styled-components";

export const StyledSection = styled.section`
  background-color: var(--blue-color-light);
  @media screen and (min-width: 576px) {
    margin-bottom: -100px;
  }
`;

export const HexWrapper = styled.div`
  width: 80%;
  display: grid;
  grid-template-areas: "item-1 item-2 item-3 item-4";
  justify-content: space-evenly;
  align-items: center;
  background-color: ${({ $homePage }) => $homePage && "var(--white-color)"};
  min-height: 260px;
  border-radius: 20px;
  position: ${({ $homePage }) => $homePage && "relative"};
  top: -143px;
  box-shadow: ${({ $homePage }) => $homePage && "rgba(0, 0, 0, 0.13) 0px 4px 90px"};

  @media screen and (max-width: 1200px) {
    width: 95%;
    justify-content: center;
  }
  @media screen and (max-width: 992px) {
    grid-template-areas:
      "item-1 item-2"
      "item-3 item-4";
    width: 75%;
  }
  @media screen and (max-width: 576px) {
    width: 85%;
  }
`;

export const Hexagon = styled(Link)`
  position: relative;
  fill: var(--blue-color-light);
  fill: ${({ $homePage }) =>
    $homePage ? "var(--blue-color-light)" : "var(--bg-color)"};
  transition: all 0.3s ease;
  display: block;
  width: max-content;
  grid-area: ${({ id }) => `item-${id}`};
  &:hover svg {
    transform: rotateZ(90deg);
  }
  svg {
    transition: all 0.3s ease;
    filter: drop-shadow(inset 1px 10px 20px #bac2c6);
    @media screen and (max-width: 576px) {
      width: 120px;
      height: 110px;
    }
  }
`;

export const HexContent = styled.div`
  position: absolute;
  z-index: 2;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  h3 {
    color: var(--dark-color);
    font-size: var(--font-size-lg);
    @media screen and (max-width: 576px) {
      font-size: var(--font-size-sm);
    }
  }
`;
